import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LspSlsRtnIndexActions, { LspSlsRtnIndexTypes } from '../Stores/LspSlsRtnIndex/Actions';

const getAppStore = state => state.app;

export function* lspSlsRtnIndexFetchLspSlsRtnIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LspSlsRtnIndexActions.lspSlsRtnIndexFetchLspSlsRtnIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `lspSlsRtn/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LspSlsRtnIndexActions.lspSlsRtnIndexFetchLspSlsRtnIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LspSlsRtnIndexActions.lspSlsRtnIndexFetchLspSlsRtnIndexLoading(false));
  }
}

export function* lspSlsRtnIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/lspSlsRtnDetail/update/${hdrId}`));
}

export function* lspSlsRtnIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/LSP_SLS_RTN/${hdrId}/LspSlsRtnHdr`));
}

export const saga = [
  takeLatest(
    LspSlsRtnIndexTypes.LSP_SLS_RTN_INDEX_FETCH_LSP_SLS_RTN_INDEX,
    lspSlsRtnIndexFetchLspSlsRtnIndex
  ),
  takeLatest(LspSlsRtnIndexTypes.LSP_SLS_RTN_INDEX_GO_TO_DOCUMENT, lspSlsRtnIndexGoToDocument),
  takeLatest(LspSlsRtnIndexTypes.LSP_SLS_RTN_INDEX_GO_TO_AUDIT, lspSlsRtnIndexGoToAudit)
];
